import type {IAnalyticsCustomersData, IResourcesUsageData} from "@torim-app/types";
import {IAnalyticsAppointmentsData, IAnalyticsDashboard} from "@torim-app/types";
import {adminUrlBuilder} from "@app/api/utils";

export class AnalyticsApi {

  static async fetchResourcesUsage(): Promise<IResourcesUsageData> {
    const url = adminUrlBuilder({}, 'analytics/resources-usage');
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (response.status === 404)
      throw "Failed to get business resource usage data";

    return await response.json();
  }

  static async fetchAppointmentsUsage(): Promise<Record<string /** Month Number **/, IAnalyticsAppointmentsData>> {
    const url = adminUrlBuilder({}, 'analytics/appointments');
    const response = await fetch(url, {
      method: 'get',
      headers: {'content-type': 'application/json'}
    });
    if (response.status === 404)
      throw "Failed to get business appointments usage data";

    return await response.json();
  }

  static async fetchAppointmentsPerDayUsage(): Promise<Record<string /** Month Number **/, Array<number>>> {
    const url = adminUrlBuilder({}, 'analytics/appointments-graph');
    const response = await fetch(url, {
      method: 'get',
      headers: {'content-type': 'application/json'}
    });
    if (response.status === 404)
      throw "Failed to get business appointments per day usage data";

    return await response.json();
  }

  static async fetchCustomersData(): Promise<Record<string /** Month Number **/, IAnalyticsCustomersData>> {
    const url = adminUrlBuilder({}, 'analytics/customers');
    const response = await fetch(url, {
      method: 'get',
      headers: {'content-type': 'application/json'}
    });
    if (response.status === 404)
      throw "Failed to get business customers data";

    return await response.json();
  }

  static async fetchMessagesData(): Promise<Record<string, IResourcesUsageData>> {
    const url = adminUrlBuilder({}, 'analytics/messages');
    const response = await fetch(url, {
      method: 'get',
      headers: {'content-type': 'application/json'}
    });
    if (response.status === 404)
      throw "Failed to get business messages data";

    return await response.json();
  }

  static async fetchDashboard(params: {startDate: string; endDate: string}): Promise<IAnalyticsDashboard> {
    const url = adminUrlBuilder({}, 'analytics/dashboard');
    const response = await fetch(url, {
      method: 'post',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify(params)
    });
    if (!response.ok)
      throw "Failed to get analytics dashboard data";

    return await response.json();
  }
}
